/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resolvePersonaDidv} from '../api'

export const useMutationResolvePersonaDidv = createReactQueryMutationHook('resolvePersonaDidv', resolvePersonaDidv)
